<template>
    <div class="growth-container">
        <div class="growth-title">
            전일 대비
        </div>
        <div class="growth-value" :class="growthDirection">
            <i v-if="growthDirection !== 'neutral'" :class="`fa-solid fa-arrow-${growthDirection}`"/>
            <div class="growth-rate">
                {{ formatPercentage }}
            </div>
        </div>
    </div>
</template>
<script>
import {
  formatCommaNumber,
  oneBtnDialog,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
export default {
    components: {
    },
    computed: {
        growthDirection() {
            if(!this.value) return 'neutral';
            if(this.value === 0) return 'neutral';
            return this.value > 0 ? 'up' : 'down';
        },
        formatPercentage() {
            if(!this.value) return '0%';
            if(this.value === 0) return '0%';
            return this.value.toFixed(1) + '%';
        },
    },
    props: {
        value: Number,
    },
    watch: {
    },
    data() {
        return {
        }
    },
    async mounted() {
    },
    methods: {
        formatCommaNumber,
    }
}
</script>
<style lang="scss">
</style>
<style scoped lang="scss">
$Gray-5: #D1D6DB;
$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$SkyBlue : #E1F0FF;
$Blue : #278AEC;
$Red: #F55247;
$Pink: #F8948E;
$LightPink: #F7D7D4;
$Orange: #FFA50A;
$Green: #22BF22;
$LightGreen: #DAF1DA;

.growth-container {
    display: flex;
    gap: 4px;
    align-items: center;
    .growth-title {
        font-size: 12px;
        font-weight: 400;
        color: $Gray-60;
    }
    .growth-value {
        display: flex;
        align-items: center;
        gap: 4px;
        border-radius: 4px;
        padding: 2px 4px;
        .growth-rate {
            font-size: 12px;
            font-weight: 400;
            color: $Gray-60;
        }
    }

    .growth-value.up {
        color: $Green;
        border: 1px solid $Green;
        background-color: $LightGreen;
        .growth-rate {
            color: $Green;
        }
    }
        .growth-value.down {
            color: $Red;
            border: 1px solid $Red;
            background-color: $LightPink;
            .growth-rate {
                color: $Red;
            }
        }
        .growth-value.neutral {
            color: $Gray-60;
            border: 1px solid $Gray-60;
            background-color: $Gray-10;
            .growth-rate {
                color: $Gray-60;
            }
        }
}
</style>